export default __webpack_public_path__ + "static/media/Rectangle.44a70f55.svg";